import { render } from "./AviesEponTable.vue?vue&type=template&id=1cf34c60&scoped=true"
import script from "./AviesEponTable.vue?vue&type=script&lang=js"
export * from "./AviesEponTable.vue?vue&type=script&lang=js"

import "./AviesEponTable.vue?vue&type=style&index=0&id=1cf34c60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf34c60"]])

export default __exports__